webpackJsonp([1],{

/***/ 109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.array-buffer.js
var es6_typed_array_buffer = __webpack_require__(110);
var es6_typed_array_buffer_default = /*#__PURE__*/__webpack_require__.n(es6_typed_array_buffer);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.int8-array.js
var es6_typed_int8_array = __webpack_require__(111);
var es6_typed_int8_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_int8_array);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.uint8-array.js
var es6_typed_uint8_array = __webpack_require__(116);
var es6_typed_uint8_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_uint8_array);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.uint8-clamped-array.js
var es6_typed_uint8_clamped_array = __webpack_require__(117);
var es6_typed_uint8_clamped_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_uint8_clamped_array);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.int16-array.js
var es6_typed_int16_array = __webpack_require__(118);
var es6_typed_int16_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_int16_array);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.uint16-array.js
var es6_typed_uint16_array = __webpack_require__(119);
var es6_typed_uint16_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_uint16_array);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.int32-array.js
var es6_typed_int32_array = __webpack_require__(120);
var es6_typed_int32_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_int32_array);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.uint32-array.js
var es6_typed_uint32_array = __webpack_require__(121);
var es6_typed_uint32_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_uint32_array);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.float32-array.js
var es6_typed_float32_array = __webpack_require__(122);
var es6_typed_float32_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_float32_array);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.float64-array.js
var es6_typed_float64_array = __webpack_require__(123);
var es6_typed_float64_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_float64_array);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.map.js
var es6_map = __webpack_require__(124);
var es6_map_default = /*#__PURE__*/__webpack_require__.n(es6_map);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.set.js
var es6_set = __webpack_require__(126);
var es6_set_default = /*#__PURE__*/__webpack_require__.n(es6_set);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.weak-map.js
var es6_weak_map = __webpack_require__(127);
var es6_weak_map_default = /*#__PURE__*/__webpack_require__.n(es6_weak_map);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.weak-set.js
var es6_weak_set = __webpack_require__(128);
var es6_weak_set_default = /*#__PURE__*/__webpack_require__.n(es6_weak_set);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.apply.js
var es6_reflect_apply = __webpack_require__(129);
var es6_reflect_apply_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_apply);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.construct.js
var es6_reflect_construct = __webpack_require__(130);
var es6_reflect_construct_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_construct);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.define-property.js
var es6_reflect_define_property = __webpack_require__(132);
var es6_reflect_define_property_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_define_property);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.delete-property.js
var es6_reflect_delete_property = __webpack_require__(133);
var es6_reflect_delete_property_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_delete_property);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.get.js
var es6_reflect_get = __webpack_require__(134);
var es6_reflect_get_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_get);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.get-own-property-descriptor.js
var es6_reflect_get_own_property_descriptor = __webpack_require__(135);
var es6_reflect_get_own_property_descriptor_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_get_own_property_descriptor);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.get-prototype-of.js
var es6_reflect_get_prototype_of = __webpack_require__(136);
var es6_reflect_get_prototype_of_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_get_prototype_of);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.has.js
var es6_reflect_has = __webpack_require__(137);
var es6_reflect_has_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_has);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.is-extensible.js
var es6_reflect_is_extensible = __webpack_require__(138);
var es6_reflect_is_extensible_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_is_extensible);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.own-keys.js
var es6_reflect_own_keys = __webpack_require__(139);
var es6_reflect_own_keys_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_own_keys);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.prevent-extensions.js
var es6_reflect_prevent_extensions = __webpack_require__(140);
var es6_reflect_prevent_extensions_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_prevent_extensions);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.set.js
var es6_reflect_set = __webpack_require__(141);
var es6_reflect_set_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_set);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.set-prototype-of.js
var es6_reflect_set_prototype_of = __webpack_require__(142);
var es6_reflect_set_prototype_of_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_set_prototype_of);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.promise.js
var es6_promise = __webpack_require__(143);
var es6_promise_default = /*#__PURE__*/__webpack_require__.n(es6_promise);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.symbol.js
var es6_symbol = __webpack_require__(147);
var es6_symbol_default = /*#__PURE__*/__webpack_require__.n(es6_symbol);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.freeze.js
var es6_object_freeze = __webpack_require__(150);
var es6_object_freeze_default = /*#__PURE__*/__webpack_require__.n(es6_object_freeze);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.seal.js
var es6_object_seal = __webpack_require__(151);
var es6_object_seal_default = /*#__PURE__*/__webpack_require__.n(es6_object_seal);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.prevent-extensions.js
var es6_object_prevent_extensions = __webpack_require__(152);
var es6_object_prevent_extensions_default = /*#__PURE__*/__webpack_require__.n(es6_object_prevent_extensions);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.is-frozen.js
var es6_object_is_frozen = __webpack_require__(153);
var es6_object_is_frozen_default = /*#__PURE__*/__webpack_require__.n(es6_object_is_frozen);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.is-sealed.js
var es6_object_is_sealed = __webpack_require__(154);
var es6_object_is_sealed_default = /*#__PURE__*/__webpack_require__.n(es6_object_is_sealed);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.is-extensible.js
var es6_object_is_extensible = __webpack_require__(155);
var es6_object_is_extensible_default = /*#__PURE__*/__webpack_require__.n(es6_object_is_extensible);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.get-own-property-descriptor.js
var es6_object_get_own_property_descriptor = __webpack_require__(156);
var es6_object_get_own_property_descriptor_default = /*#__PURE__*/__webpack_require__.n(es6_object_get_own_property_descriptor);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.get-prototype-of.js
var es6_object_get_prototype_of = __webpack_require__(157);
var es6_object_get_prototype_of_default = /*#__PURE__*/__webpack_require__.n(es6_object_get_prototype_of);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__(158);
var es6_object_keys_default = /*#__PURE__*/__webpack_require__.n(es6_object_keys);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.get-own-property-names.js
var es6_object_get_own_property_names = __webpack_require__(159);
var es6_object_get_own_property_names_default = /*#__PURE__*/__webpack_require__.n(es6_object_get_own_property_names);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.assign.js
var es6_object_assign = __webpack_require__(160);
var es6_object_assign_default = /*#__PURE__*/__webpack_require__.n(es6_object_assign);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.is.js
var es6_object_is = __webpack_require__(161);
var es6_object_is_default = /*#__PURE__*/__webpack_require__.n(es6_object_is);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.set-prototype-of.js
var es6_object_set_prototype_of = __webpack_require__(162);
var es6_object_set_prototype_of_default = /*#__PURE__*/__webpack_require__.n(es6_object_set_prototype_of);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__(163);
var es6_function_name_default = /*#__PURE__*/__webpack_require__.n(es6_function_name);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.raw.js
var es6_string_raw = __webpack_require__(164);
var es6_string_raw_default = /*#__PURE__*/__webpack_require__.n(es6_string_raw);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.from-code-point.js
var es6_string_from_code_point = __webpack_require__(165);
var es6_string_from_code_point_default = /*#__PURE__*/__webpack_require__.n(es6_string_from_code_point);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.code-point-at.js
var es6_string_code_point_at = __webpack_require__(166);
var es6_string_code_point_at_default = /*#__PURE__*/__webpack_require__.n(es6_string_code_point_at);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.repeat.js
var es6_string_repeat = __webpack_require__(167);
var es6_string_repeat_default = /*#__PURE__*/__webpack_require__.n(es6_string_repeat);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.starts-with.js
var es6_string_starts_with = __webpack_require__(168);
var es6_string_starts_with_default = /*#__PURE__*/__webpack_require__.n(es6_string_starts_with);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.ends-with.js
var es6_string_ends_with = __webpack_require__(169);
var es6_string_ends_with_default = /*#__PURE__*/__webpack_require__.n(es6_string_ends_with);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__(170);
var es6_string_includes_default = /*#__PURE__*/__webpack_require__.n(es6_string_includes);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.flags.js
var es6_regexp_flags = __webpack_require__(171);
var es6_regexp_flags_default = /*#__PURE__*/__webpack_require__.n(es6_regexp_flags);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.match.js
var es6_regexp_match = __webpack_require__(172);
var es6_regexp_match_default = /*#__PURE__*/__webpack_require__.n(es6_regexp_match);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.replace.js
var es6_regexp_replace = __webpack_require__(174);
var es6_regexp_replace_default = /*#__PURE__*/__webpack_require__.n(es6_regexp_replace);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.split.js
var es6_regexp_split = __webpack_require__(175);
var es6_regexp_split_default = /*#__PURE__*/__webpack_require__.n(es6_regexp_split);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.search.js
var es6_regexp_search = __webpack_require__(176);
var es6_regexp_search_default = /*#__PURE__*/__webpack_require__.n(es6_regexp_search);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.from.js
var es6_array_from = __webpack_require__(177);
var es6_array_from_default = /*#__PURE__*/__webpack_require__.n(es6_array_from);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.of.js
var es6_array_of = __webpack_require__(178);
var es6_array_of_default = /*#__PURE__*/__webpack_require__.n(es6_array_of);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.copy-within.js
var es6_array_copy_within = __webpack_require__(179);
var es6_array_copy_within_default = /*#__PURE__*/__webpack_require__.n(es6_array_copy_within);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find.js
var es6_array_find = __webpack_require__(180);
var es6_array_find_default = /*#__PURE__*/__webpack_require__.n(es6_array_find);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find-index.js
var es6_array_find_index = __webpack_require__(181);
var es6_array_find_index_default = /*#__PURE__*/__webpack_require__.n(es6_array_find_index);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.fill.js
var es6_array_fill = __webpack_require__(182);
var es6_array_fill_default = /*#__PURE__*/__webpack_require__.n(es6_array_fill);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.iterator.js
var es6_array_iterator = __webpack_require__(64);
var es6_array_iterator_default = /*#__PURE__*/__webpack_require__.n(es6_array_iterator);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.is-finite.js
var es6_number_is_finite = __webpack_require__(183);
var es6_number_is_finite_default = /*#__PURE__*/__webpack_require__.n(es6_number_is_finite);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.is-integer.js
var es6_number_is_integer = __webpack_require__(184);
var es6_number_is_integer_default = /*#__PURE__*/__webpack_require__.n(es6_number_is_integer);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.is-safe-integer.js
var es6_number_is_safe_integer = __webpack_require__(185);
var es6_number_is_safe_integer_default = /*#__PURE__*/__webpack_require__.n(es6_number_is_safe_integer);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.is-nan.js
var es6_number_is_nan = __webpack_require__(186);
var es6_number_is_nan_default = /*#__PURE__*/__webpack_require__.n(es6_number_is_nan);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.epsilon.js
var es6_number_epsilon = __webpack_require__(187);
var es6_number_epsilon_default = /*#__PURE__*/__webpack_require__.n(es6_number_epsilon);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.min-safe-integer.js
var es6_number_min_safe_integer = __webpack_require__(188);
var es6_number_min_safe_integer_default = /*#__PURE__*/__webpack_require__.n(es6_number_min_safe_integer);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.max-safe-integer.js
var es6_number_max_safe_integer = __webpack_require__(189);
var es6_number_max_safe_integer_default = /*#__PURE__*/__webpack_require__.n(es6_number_max_safe_integer);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.acosh.js
var es6_math_acosh = __webpack_require__(190);
var es6_math_acosh_default = /*#__PURE__*/__webpack_require__.n(es6_math_acosh);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.asinh.js
var es6_math_asinh = __webpack_require__(191);
var es6_math_asinh_default = /*#__PURE__*/__webpack_require__.n(es6_math_asinh);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.atanh.js
var es6_math_atanh = __webpack_require__(192);
var es6_math_atanh_default = /*#__PURE__*/__webpack_require__.n(es6_math_atanh);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.cbrt.js
var es6_math_cbrt = __webpack_require__(193);
var es6_math_cbrt_default = /*#__PURE__*/__webpack_require__.n(es6_math_cbrt);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.clz32.js
var es6_math_clz32 = __webpack_require__(194);
var es6_math_clz32_default = /*#__PURE__*/__webpack_require__.n(es6_math_clz32);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.cosh.js
var es6_math_cosh = __webpack_require__(195);
var es6_math_cosh_default = /*#__PURE__*/__webpack_require__.n(es6_math_cosh);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.expm1.js
var es6_math_expm1 = __webpack_require__(196);
var es6_math_expm1_default = /*#__PURE__*/__webpack_require__.n(es6_math_expm1);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.fround.js
var es6_math_fround = __webpack_require__(197);
var es6_math_fround_default = /*#__PURE__*/__webpack_require__.n(es6_math_fround);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.hypot.js
var es6_math_hypot = __webpack_require__(199);
var es6_math_hypot_default = /*#__PURE__*/__webpack_require__.n(es6_math_hypot);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.imul.js
var es6_math_imul = __webpack_require__(200);
var es6_math_imul_default = /*#__PURE__*/__webpack_require__.n(es6_math_imul);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.log1p.js
var es6_math_log1p = __webpack_require__(201);
var es6_math_log1p_default = /*#__PURE__*/__webpack_require__.n(es6_math_log1p);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.log10.js
var es6_math_log10 = __webpack_require__(202);
var es6_math_log10_default = /*#__PURE__*/__webpack_require__.n(es6_math_log10);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.log2.js
var es6_math_log2 = __webpack_require__(203);
var es6_math_log2_default = /*#__PURE__*/__webpack_require__.n(es6_math_log2);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.sign.js
var es6_math_sign = __webpack_require__(204);
var es6_math_sign_default = /*#__PURE__*/__webpack_require__.n(es6_math_sign);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.sinh.js
var es6_math_sinh = __webpack_require__(205);
var es6_math_sinh_default = /*#__PURE__*/__webpack_require__.n(es6_math_sinh);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.tanh.js
var es6_math_tanh = __webpack_require__(206);
var es6_math_tanh_default = /*#__PURE__*/__webpack_require__.n(es6_math_tanh);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.trunc.js
var es6_math_trunc = __webpack_require__(207);
var es6_math_trunc_default = /*#__PURE__*/__webpack_require__.n(es6_math_trunc);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__(208);
var es7_array_includes_default = /*#__PURE__*/__webpack_require__.n(es7_array_includes);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.values.js
var es7_object_values = __webpack_require__(209);
var es7_object_values_default = /*#__PURE__*/__webpack_require__.n(es7_object_values);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.entries.js
var es7_object_entries = __webpack_require__(210);
var es7_object_entries_default = /*#__PURE__*/__webpack_require__.n(es7_object_entries);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__(211);
var es7_object_get_own_property_descriptors_default = /*#__PURE__*/__webpack_require__.n(es7_object_get_own_property_descriptors);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.string.pad-start.js
var es7_string_pad_start = __webpack_require__(212);
var es7_string_pad_start_default = /*#__PURE__*/__webpack_require__.n(es7_string_pad_start);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.string.pad-end.js
var es7_string_pad_end = __webpack_require__(213);
var es7_string_pad_end_default = /*#__PURE__*/__webpack_require__.n(es7_string_pad_end);

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.timers.js
var web_timers = __webpack_require__(214);
var web_timers_default = /*#__PURE__*/__webpack_require__.n(web_timers);

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.immediate.js
var web_immediate = __webpack_require__(215);
var web_immediate_default = /*#__PURE__*/__webpack_require__.n(web_immediate);

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__(216);
var web_dom_iterable_default = /*#__PURE__*/__webpack_require__.n(web_dom_iterable);

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(217);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);

// EXTERNAL MODULE: ./node_modules/svgxuse/svgxuse.js
var svgxuse = __webpack_require__(218);
var svgxuse_default = /*#__PURE__*/__webpack_require__.n(svgxuse);

// EXTERNAL MODULE: ./node_modules/object-fit-images/dist/ofi.common-js.js
var ofi_common_js = __webpack_require__(219);
var ofi_common_js_default = /*#__PURE__*/__webpack_require__.n(ofi_common_js);

// EXTERNAL MODULE: ./___src/assets/js/lib/bling.js
var bling = __webpack_require__(220);
var bling_default = /*#__PURE__*/__webpack_require__.n(bling);

// EXTERNAL MODULE: ./___src/assets/css/app.scss
var app = __webpack_require__(221);
var app_default = /*#__PURE__*/__webpack_require__.n(app);

// EXTERNAL MODULE: ./___src/assets/js/scripts/prism.js
var prism = __webpack_require__(222);
var prism_default = /*#__PURE__*/__webpack_require__.n(prism);

// CONCATENATED MODULE: ./___src/assets/js/scripts/bodyclass.js
/**
 * bodyClass
 */

var bodyClass = {
    cfg: {
        body: document.body,
        steps: 500,
        duration: 3000,
        timer: 0,
        i: 1
    },

    setClass: function setClass() {
        this.cfg.body.classList.add('is-' + this.cfg.i * this.cfg.steps + 'ms');
        this.cfg.i += 1;
    },
    timer: function timer() {
        var _this = this;

        while (this.cfg.timer <= this.cfg.duration) {
            if (this.cfg.timer === 0) {
                this.cfg.body.classList.add('is-ready');
            } else {
                setTimeout(function () {
                    _this.setClass();
                }, this.cfg.timer);
            }
            this.cfg.timer += this.cfg.steps;
        }
    },
    init: function init() {
        this.timer();
    }
};

/* harmony default export */ var bodyclass = (bodyClass);
// CONCATENATED MODULE: ./___src/assets/js/scripts/disableHover.js
/**
 * disableHover
 */

var disableHover = {
    cfg: {
        body: document.body,
        timer: ''
    },

    setClasses: function setClasses() {
        var _this = this;

        clearTimeout(this.cfg.timer);
        if (!this.cfg.body.classList.contains('no-hover')) {
            this.cfg.body.classList.add('no-hover');
        }
        this.cfg.timer = setTimeout(function () {
            _this.cfg.body.classList.remove('no-hover');
        }, 250);
    },
    init: function init() {
        window.addEventListener('scroll', this.setClasses.bind(this), false);
    }
};

/* harmony default export */ var scripts_disableHover = (disableHover);
// EXTERNAL MODULE: ./node_modules/bowser/src/bowser.js
var bowser = __webpack_require__(223);
var bowser_default = /*#__PURE__*/__webpack_require__.n(bowser);

// CONCATENATED MODULE: ./___src/assets/js/scripts/bowser.js
/**
 * preloader
 */



var browserDetect = {
    cfg: {
        customOutput: true,
        docHead: document.querySelector('html'),
        // eslint-disable-next-line
        version: typeof bowser_default.a.version === 'undefined' ? null : bowser_default.a.version.toLowerCase().replace(' ', '-').split('.', 1)[0],
        name: bowser_default.a.name.toLowerCase().replace(' ', '-')
    },

    detectBrowser: function detectBrowser() {
        if (this.cfg.customOutput) {
            // Use the switch condition if you want to customize the output
            switch (bowser_default.a.name) {
                case 'Microsoft Edge':
                    this.cfg.docHead.classList.add('edge', 'edge-' + this.cfg.version);
                    break;

                case 'Internet Explorer':
                    this.cfg.docHead.classList.add('ie', 'ie-' + this.cfg.version);
                    break;

                case 'Firefox':
                    this.cfg.docHead.classList.add('firefox', 'firefox-' + this.cfg.version);
                    break;

                case 'Safari':
                    this.cfg.docHead.classList.add('safari', 'safari-' + this.cfg.version);
                    break;

                case 'Chrome':
                    this.cfg.docHead.classList.add('chrome', 'chrome-' + this.cfg.version);
                    break;

                default:
            }

            // Generate Class for Browser with the old CSS Grid Spec
            var oldSpecBrowser = ['internet-explorer-10', 'internet-explorer-11', 'microsoft-edge-12', 'microsoft-edge-13', 'microsoft-edge-14', 'microsoft-edge-15'];

            if (oldSpecBrowser.includes(this.cfg.name + '-' + this.cfg.version)) {
                this.cfg.docHead.classList.add('t-oldies');
            }
        } else {
            // Generate Classes based on Browser and BrowserVersion
            this.cfg.docHead.classList.add(this.cfg.name, this.cfg.name + '-' + this.cfg.version);
        }
    },
    init: function init() {
        this.detectBrowser();
    }
};

/* harmony default export */ var scripts_bowser = (browserDetect);
// CONCATENATED MODULE: ./___src/assets/js/scripts/resizeClass.js
/**
 * bodyClass
 */

var resizeClass = {
    cfg: {
        body: document.body,
        timer: null
    },

    isDoneResizing: function isDoneResizing() {
        this.cfg.body.classList.remove('is-resizing');
        this.cfg.body.classList.add('is-resized');
    },
    isResizing: function isResizing() {
        this.cfg.body.classList.add('is-resizing');
        this.cfg.body.classList.remove('is-resized');
    },
    init: function init() {
        var _this = this;

        window.addEventListener('resize', function () {
            _this.isResizing();

            clearTimeout(_this.cfg.timer);
            _this.cfg.timer = setTimeout(function () {
                _this.isDoneResizing();
            }, 250);
        });
    }
};

/* harmony default export */ var scripts_resizeClass = (resizeClass);
// EXTERNAL MODULE: ./node_modules/lazysizes/lazysizes.js
var lazysizes = __webpack_require__(53);
var lazysizes_default = /*#__PURE__*/__webpack_require__.n(lazysizes);

// EXTERNAL MODULE: ./node_modules/lazysizes/plugins/respimg/ls.respimg.js
var ls_respimg = __webpack_require__(225);
var ls_respimg_default = /*#__PURE__*/__webpack_require__.n(ls_respimg);

// EXTERNAL MODULE: ./node_modules/lazysizes/plugins/parent-fit/ls.parent-fit.js
var ls_parent_fit = __webpack_require__(227);
var ls_parent_fit_default = /*#__PURE__*/__webpack_require__.n(ls_parent_fit);

// CONCATENATED MODULE: ./___src/assets/js/scripts/lazyloading.js
/**
 * Lazy Loading
 */

// Dependencies

// import '../../../../node_modules/lazysizes/plugins/bgset/ls.bgset'
// import '../../../../node_modules/lazysizes/plugins/respimg/ls.respimg';



// Settings
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.expand = 500; // default 360-500
window.lazySizesConfig.expFactor = 1.7; // default: 1.7
// EXTERNAL MODULE: ./___src/assets/js/scripts/fontfaceobserver.js
var fontfaceobserver = __webpack_require__(228);
var fontfaceobserver_default = /*#__PURE__*/__webpack_require__.n(fontfaceobserver);

// EXTERNAL MODULE: ./node_modules/scrollmonitor/scrollMonitor.js
var scrollMonitor = __webpack_require__(229);
var scrollMonitor_default = /*#__PURE__*/__webpack_require__.n(scrollMonitor);

// CONCATENATED MODULE: ./___src/assets/js/scripts/scrollmonitor.js
/**
 * ScrollMonitor
 */


// import anime from '../../../../node_modules/animejs/anime'

var scrollMonitorScript = {
    doAnimation: function doAnimation(triggers) {
        triggers.forEach(function (trigger) {
            var elementWatcher = scrollMonitor_default.a.create(trigger, -100);

            elementWatcher.enterViewport(function () {
                var waypoints = trigger.querySelectorAll('[data-waypoint]');

                var _loop = function _loop(i) {
                    var obj = waypoints[i];
                    var delay = 150 + 100 * i;

                    if (!obj.classList.contains('is-animated')) {
                        if (obj.classList.contains('is-fadeInUp')) {
                            setTimeout(function () {
                                obj.classList.add('is-animated');
                            }, delay);
                        }
                    }
                };

                for (var i = 0; i < waypoints.length; i += 1) {
                    _loop(i);
                }
            });
        });
    },
    init: function init() {
        var triggers = document.querySelectorAll('.js-waypointTrigger');
        if (triggers) {
            this.doAnimation(triggers);
        }
    }
};

/* harmony default export */ var scrollmonitor = (scrollMonitorScript);
// CONCATENATED MODULE: ./___src/assets/js/partials/scripts.js
/**
 * Scripts
 */







// import '../scripts/pagetransition'
// import '../scripts/smoothScroll'
// import '../scripts/waypoints.anime'


// Modules Array
var scriptsArray = [bodyclass, scripts_disableHover, scripts_bowser, scripts_resizeClass, scrollmonitor];

var scripts = {
    // Scripts
    Scripts: function Scripts() {
        if (scriptsArray.length > 0 && scriptsArray !== undefined) {
            scriptsArray.forEach(function (script) {
                script.init();
            });
        }
    },
    init: function init() {
        this.Scripts();
    }
};

/* harmony default export */ var partials_scripts = (scripts);
// CONCATENATED MODULE: ./___src/assets/js/partials/templates.js
/**
 * templates
 */

// Import Templats
// import toggleContent from '../../../templates/_templates/toggleContent/_main'

// Modules Array
var templatesArray = [
    // toggleContent
];

var templates = {
    // Modules
    Templates: function Templates() {
        if (templatesArray.length > 0 && templatesArray !== undefined) {
            templatesArray.forEach(function (template) {
                template.init();
            });
        }
    },
    init: function init() {
        this.Templates();
    }
};

/* harmony default export */ var partials_templates = (templates);
// CONCATENATED MODULE: ./___src/templates/_atoms/preloader/_script.js
/**
 * preloader
 */

var preloader = {
    cfg: {
        body: document.getElementsByTagName('body')[0],
        bar: document.querySelector('.a-preloader'),
        states: {
            loading: 'is-loading',
            interact: 'is-interactive',
            complete: 'is-complete'
        },
        barstates: {
            loading: 'a-preloader--loading',
            complete: 'a-preloader--complete'
        }
    },

    stateLoading: function stateLoading() {
        this.cfg.body.classList.add(this.cfg.states.loading);

        // Start Preloader Bar
        this.cfg.bar.classList.add(this.cfg.barstates.loading);
    },
    stateInteractive: function stateInteractive() {
        this.cfg.body.classList.remove(this.cfg.states.loading);
        this.cfg.body.classList.add(this.cfg.states.interact);
    },
    stateComplete: function stateComplete() {
        var _this = this;

        setTimeout(function () {
            // Change Classes for Preloader Bar
            _this.cfg.bar.classList.remove(_this.cfg.barstates.loading);
            _this.cfg.bar.classList.add(_this.cfg.barstates.complete);
        }, 125);

        setTimeout(function () {
            _this.cfg.body.classList.remove(_this.cfg.states.interact);
            _this.cfg.body.classList.add(_this.cfg.states.complete);
        }, 500);
    },
    progressLoader: function progressLoader() {
        var _this2 = this;

        this.stateLoading();
        this.stateInteractive();

        document.onreadystatechange = function () {
            if (document.readyState === 'complete') {
                _this2.stateComplete();
            }
        };
    },
    init: function init() {
        if (!this.cfg.body.classList.contains('is-livePreview') && document.getElementsByTagName('html')[0].classList.contains('js')) {
            this.progressLoader();
        }
    }
};

/* harmony default export */ var _script = (preloader);
// CONCATENATED MODULE: ./___src/templates/_atoms/codeSnippet/_script.js
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * code
 */

var codeSnippet = {
    cfg: {
        codeBlocks: [].concat(_toConsumableArray(document.querySelectorAll('.js-codeSnippet')))
    },

    toggleCodeBlock: function toggleCodeBlock(els) {
        els.forEach(function (el) {
            var toggle = el.nextElementSibling;
            var status = el.getAttribute('data-status');
            var textHolder = toggle.querySelector('.js-textHolder');
            var showText = toggle.getAttribute('data-show');
            var hideText = toggle.getAttribute('data-hide');

            toggle.addEventListener('click', function () {
                if (status === 'open') {
                    status = 'closed';
                    textHolder.innerHTML = showText;
                    toggle.setAttribute('data-status', 'closed');
                    toggle.previousElementSibling.setAttribute('data-status', 'closed');
                } else {
                    status = 'open';
                    textHolder.innerHTML = hideText;
                    toggle.setAttribute('data-status', 'open');
                    toggle.previousElementSibling.setAttribute('data-status', 'open');
                }
            });
        });
    },
    init: function init() {
        if (this.cfg.codeBlocks) {
            this.toggleCodeBlock(this.cfg.codeBlocks);
        }
    }
};

/* harmony default export */ var codeSnippet__script = (codeSnippet);
// EXTERNAL MODULE: ./node_modules/flickity/js/index.js
var js = __webpack_require__(75);
var js_default = /*#__PURE__*/__webpack_require__.n(js);

// CONCATENATED MODULE: ./___src/templates/_organisms/imageSlider/_script.js
function _script__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Image Slider
 */



var imageSlider = {
    cfg: {
        slider: '.js-imageSlider',
        sliderOptions: {
            cellAlign: 'left',
            contain: true,
            draggable: true,
            friction: 1,
            lazyLoad: 2,
            selectedAttraction: 0.1,
            groupCells: true,
            setGallerySize: true,
            imagesLoaded: true,
            prevNextButtons: true,
            pageDots: true,
            wrapAround: false
            // watchCSS: true

        }
    },

    init: function init() {
        var _this = this;

        window.addEventListener('load', function () {
            var sliders = [].concat(_script__toConsumableArray(document.querySelectorAll(_this.cfg.slider)));
            if (sliders) {
                sliders.forEach(function (slider) {
                    var flkty = new js_default.a(slider, _this.cfg.sliderOptions);
                    flkty.resize();

                    setTimeout(function () {
                        flkty.resize();
                        slider.classList.add('is-ready');
                    }, 1000);
                });
            }
        });
    }
};

/* harmony default export */ var imageSlider__script = (imageSlider);
// EXTERNAL MODULE: ./node_modules/photoswipe/dist/photoswipe.js
var photoswipe = __webpack_require__(241);
var photoswipe_default = /*#__PURE__*/__webpack_require__.n(photoswipe);

// EXTERNAL MODULE: ./node_modules/photoswipe/dist/photoswipe-ui-default.js
var photoswipe_ui_default = __webpack_require__(242);
var photoswipe_ui_default_default = /*#__PURE__*/__webpack_require__.n(photoswipe_ui_default);

// CONCATENATED MODULE: ./___src/templates/_organisms/imageGallery/_script.js
/**
 * imageGallery (Photoswipe
 */

// Dependencies



/* eslint-disable */
var imageGallery = {
    creatGallery: function creatGallery(gallerySelector) {
        // parse slide data (url, title, size ...) from DOM elements
        // (children of gallerySelector)
        var parseThumbnailElements = function parseThumbnailElements(el) {
            var thumbElements = el.childNodes;
            var numNodes = thumbElements.length;
            var items = [];
            var figureEl = void 0;
            var linkEl = void 0;
            var size = void 0;
            var item = void 0;

            for (var i = 0; i < numNodes; i++) {

                figureEl = thumbElements[i]; // <figure> element

                // include only element nodes
                if (figureEl.nodeType !== 1) {
                    continue;
                }

                linkEl = figureEl.getElementsByTagName('a')[0]; // <a> element

                size = linkEl.getAttribute('data-size').split('x');

                // create slide object
                item = {
                    src: linkEl.getAttribute('href'),
                    w: parseInt(size[0], 10),
                    h: parseInt(size[1], 10)
                };

                if (figureEl.children.length > 1) {
                    // <figcaption> content
                    item.title = figureEl.children[1].innerHTML;
                }

                console.log(figureEl.children.length);

                if (linkEl.children.length > 0) {
                    // <img> thumbnail element, retrieving thumbnail url
                    item.msrc = linkEl.children[0].getAttribute('data-photoswipe-thumb');
                }

                item.el = figureEl; // save link to element for getThumbBoundsFn
                items.push(item);
            }

            return items;
        };

        // find nearest parent element
        var closest = function closest(el, fn) {
            return el && (fn(el) ? el : closest(el.parentNode, fn));
        };

        // triggers when user clicks on thumbnail
        var onThumbnailsClick = function onThumbnailsClick(e) {

            e = e || window.event;
            e.preventDefault ? e.preventDefault() : e.returnValue = false;

            var eTarget = e.target || e.srcElement;

            // find root element of slide
            var clickedListItem = closest(eTarget, function (el) {
                return el.tagName && el.tagName.toUpperCase() === 'FIGURE';
            });

            if (!clickedListItem) {
                return;
            }

            // find index of clicked item by looping through all child nodes
            // alternatively, you may define index via data- attribute
            var clickedGallery = clickedListItem.parentNode,
                childNodes = clickedListItem.parentNode.childNodes,
                numChildNodes = childNodes.length,
                nodeIndex = 0,
                index;

            for (var i = 0; i < numChildNodes; i++) {
                if (childNodes[i].nodeType !== 1) {
                    continue;
                }

                if (childNodes[i] === clickedListItem) {
                    index = nodeIndex;
                    break;
                }
                nodeIndex++;
            }

            if (index >= 0) {
                // open PhotoSwipe if valid index found
                openPhotoSwipe(index, clickedGallery);
            }
            return false;
        };

        // parse picture index and gallery index from URL (#&pid=1&gid=2)
        var photoswipeParseHash = function photoswipeParseHash() {
            var hash = window.location.hash.substring(1),
                params = {};

            if (hash.length < 5) {
                return params;
            }

            var vars = hash.split('&');
            for (var i = 0; i < vars.length; i++) {
                if (!vars[i]) {
                    continue;
                }
                var pair = vars[i].split('=');
                if (pair.length < 2) {
                    continue;
                }
                params[pair[0]] = pair[1];
            }

            if (params.gid) {
                params.gid = parseInt(params.gid, 10);
            }

            return params;
        };

        var openPhotoSwipe = function openPhotoSwipe(index, galleryElement, disableAnimation, fromURL) {
            var pswpElement = document.querySelectorAll('.pswp')[0],
                gallery,
                options,
                items;

            items = parseThumbnailElements(galleryElement);

            // define options (if needed)
            options = {

                closeEl: true,
                captionEl: true,
                fullscreenEl: true,
                zoomEl: true,
                shareEl: false,
                counterEl: true,
                arrowEl: true,
                preloaderEl: true,

                showHideOpacity: true,

                // define gallery index (for URL)
                galleryUID: galleryElement.getAttribute('data-pswp-uid'),

                getThumbBoundsFn: function getThumbBoundsFn(index) {
                    // See Options -> getThumbBoundsFn section of documentation for more info
                    var thumbnail = items[index].el.getElementsByTagName('img')[0],
                        // find thumbnail
                    pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                        rect = thumbnail.getBoundingClientRect();

                    return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
                }

            };

            // PhotoSwipe opened from URL
            if (fromURL) {
                if (options.galleryPIDs) {
                    // parse real index when custom PIDs are used
                    // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
                    for (var j = 0; j < items.length; j++) {
                        if (items[j].pid == index) {
                            options.index = j;
                            break;
                        }
                    }
                } else {
                    // in URL indexes start from 1
                    options.index = parseInt(index, 10) - 1;
                }
            } else {
                options.index = parseInt(index, 10);
            }

            // exit if index not found
            if (isNaN(options.index)) {
                return;
            }

            if (disableAnimation) {
                options.showAnimationDuration = 0;
            }

            // Pass data to PhotoSwipe and initialize it
            gallery = new photoswipe_default.a(pswpElement, photoswipe_ui_default_default.a, items, options);
            gallery.init();
        };

        // loop through all gallery elements and bind events
        var galleryElements = document.querySelectorAll(gallerySelector);

        for (var i = 0, l = galleryElements.length; i < l; i++) {
            galleryElements[i].setAttribute('data-pswp-uid', i + 1);
            galleryElements[i].onclick = onThumbnailsClick;
        }

        // Parse URL and open gallery if it contains #&pid=3&gid=1
        var hashData = photoswipeParseHash();
        if (hashData.pid && hashData.gid) {
            openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
        }
    },
    addCode: function addCode() {
        var html = '\n            <!-- Root element of PhotoSwipe. Must have class pswp. #} -->\n            <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">\n              <div class="pswp__bg"></div>\n              <div class="pswp__scroll-wrap">\n                <!-- don\'t modify these 3 pswp__item elements, data is added later on. -->\n                <div class="pswp__container">\n                  <div class="pswp__item"></div>\n                  <div class="pswp__item"></div>\n                  <div class="pswp__item"></div>\n                </div>\n                <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->\n                <div class="pswp__ui pswp__ui--hidden">\n                  <div class="pswp__top-bar">\n                    <!-- Controls are self-explanatory. Order can be changed. -->\n                    <div class="pswp__counter"></div>\n                    <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>\n                    <button class="pswp__button pswp__button--share" title="Share"></button>\n                    <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>\n                    <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>\n                    <div class="pswp__preloader">\n                      <div class="pswp__preloader__icn">\n                        <div class="pswp__preloader__cut">\n                          <div class="pswp__preloader__donut"></div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                  <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">\n                    <div class="pswp__share-tooltip"></div>\n                  </div>\n                  <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">\n                  </button>\n                  <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">\n                  </button>\n                  <div class="pswp__caption">\n                    <div class="pswp__caption__center"></div>\n                  </div>\n                </div>\n              </div>\n            </div>\n        ';

        document.body.insertAdjacentHTML('beforeend', html);
    },
    init: function init() {
        var gallery = document.querySelector('.js-imageGallery');
        if (gallery) {
            this.addCode();
            this.creatGallery('.js-imageGallery');
        }
    }
};
/* eslint-enable */
/* harmony default export */ var imageGallery__script = (imageGallery);
// EXTERNAL MODULE: ./node_modules/hide-on-scroll/navbar.es5.js
var navbar_es5 = __webpack_require__(243);
var navbar_es5_default = /*#__PURE__*/__webpack_require__.n(navbar_es5);

// CONCATENATED MODULE: ./___src/templates/_organisms/appHeader/_script.js
/*
 * Description of what this file is for
 *
 * @package  craft3
 * @author Stefan Prosch [hello@stefanprosch.com]
 * appHeader
 */



var delay = function delay(ms) {
    return new Promise(function (_) {
        return setTimeout(_, ms);
    });
};
var bodyScrollLock = __webpack_require__(244);

/* eslint-disable */
var disableBodyScroll = bodyScrollLock.disableBodyScroll;
var enableBodyScroll = bodyScrollLock.enableBodyScroll;
/* eslint-enable */

var appHeader = {
    cfg: {
        body: document.getElementsByTagName('body')[0],
        appHeader: document.querySelector('.js-appHeader'),
        mainNav: document.querySelector('.js-menu'),
        navWrapper: document.querySelector('.js-wrapper'),
        navBarToggle: document.querySelector('.js-navbarToggle')
    },

    init: function init() {
        var _this = this;

        this.cfg.navBarToggle.addEventListener('click', function () {
            _this.cfg.navWrapper.classList.toggle('active');
            _this.cfg.navBarToggle.classList.toggle('active');

            if (_this.cfg.navBarToggle.classList.contains('active')) {
                _this.cfg.mainNav.classList.add('active');
                _this.cfg.appHeader.classList.add('active');
                // this.cfg.body.style.overflow = 'hidden';
                _this.cfg.body.classList.add('is-open--navigation');
                disableBodyScroll(_this.cfg.navWrapper);
            } else {
                delay(700).then(function () {
                    return _this.cfg.mainNav.classList.remove('active');
                });
                delay(700).then(function () {
                    return _this.cfg.appHeader.classList.remove('active');
                });
                // this.cfg.body.style.overflow = '';
                _this.cfg.body.classList.remove('is-open--navigation');
                enableBodyScroll(_this.cfg.navWrapper);
            }
        });

        navbar_es5_default()({
            navbarSelector: '.js-appHeader',
            hidingClass: 'o-appHeader--isHidden',
            pollingInterval: 500
        });
    }
};

/* harmony default export */ var appHeader__script = (appHeader);
// CONCATENATED MODULE: ./___src/templates/_organisms/newsList/_script.js
function newsList__script__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Image Slider
 */



var newsList = {
    cfg: {
        slider: '.js-newsList',
        sliderOptions: {
            cellAlign: 'left',
            contain: true,
            draggable: true,
            friction: 1,
            lazyLoad: 2,
            selectedAttraction: 0.1,
            groupCells: false,
            setGallerySize: true,
            imagesLoaded: true,
            prevNextButtons: true,
            pageDots: true,
            wrapAround: false
            // watchCSS: true

        },
        viewportWidth: '',
        sliders: '',
        flkty: ''
    },

    flickity: function flickity() {
        var _this = this;

        this.cfg.sliders = [].concat(newsList__script__toConsumableArray(document.querySelectorAll(this.cfg.slider)));

        if (this.cfg.sliders.length > 0) {
            // this.cfg.sliders = [...document.querySelectorAll(this.cfg.slider)];
            this.cfg.flkty.destroy();

            if (this.cfg.sliders.length > 0) {
                this.cfg.sliders.forEach(function (slider) {
                    if (window.innerWidth || document.documentElement.clientWidth >= 800) {
                        _this.cfg.flkty.destroy();
                        setTimeout(function () {
                            _this.cfg.flkty.resize();
                            slider.classList.remove('is-ready');
                        }, 1000);
                    } else {
                        _this.cfg.flkty = new js_default.a(slider, _this.cfg.sliderOptions);

                        _this.cfg.flkty.resize();

                        setTimeout(function () {
                            _this.cfg.flkty.resize();
                            slider.classList.add('is-ready');
                        }, 1000);
                    }
                });
            }
        }
    },
    init: function init() {
        // this.flickity();
        // window.addEventListener('load', this.flickity);
        // window.addEventListener('resize', this.flickity);

        /* window.addEventListener('load', () => {
            const sliders = [...document.querySelectorAll(this.cfg.slider)];
            if (sliders) {
                sliders.forEach((slider) => {
                    const flkty = new Flickity(slider, this.cfg.sliderOptions);
                    flkty.resize();
                     setTimeout(() => {
                        flkty.resize();
                        slider.classList.add('is-ready');
                    }, 1000);
                });
            }
        }); */
    }
};

/* harmony default export */ var newsList__script = (newsList);
// EXTERNAL MODULE: ./node_modules/fitty/dist/fitty.module.js
var fitty_module = __webpack_require__(245);

// EXTERNAL MODULE: ./node_modules/animejs/anime.min.js
var anime_min = __webpack_require__(108);
var anime_min_default = /*#__PURE__*/__webpack_require__.n(anime_min);

// EXTERNAL MODULE: ./node_modules/scrollmagic/scrollmagic/uncompressed/ScrollMagic.js
var ScrollMagic = __webpack_require__(246);
var ScrollMagic_default = /*#__PURE__*/__webpack_require__.n(ScrollMagic);

// CONCATENATED MODULE: ./___src/templates/_organisms/pageTitle/_script.js
function pageTitle__script__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/*
 * Description of what this file is for
 *
 * @package  baukasten
 * @author David Hellmann [davidhellmann.com@gmail.com]
 * pageTitle
 */

// import scrollMonitor from 'scrollmonitor';
// import TweenMax from '../../../../node_modules/gsap/TweenMax';



// import TimelineMax from '../../../../node_modules/gsap/src/uncompressed/TimelineMax';
// import Power2 from '../../../../node_modules/gsap/src/uncompressed/TweenLite';

var pageTitle = {
    cfg: {
        name: 'pageTitle',
        controller: '',
        trigger: document.querySelectorAll('.js-pageTitle'),
        tweenObj: {
            targets: '.js-figure .m-figure__image',
            translateX: '5%',
            scale: 1.1,
            elasticity: 0.5,
            autoplay: false,
            easing: 'linear'
        },
        timeline: anime_min_default.a.timeline(),
        scene: '',
        elements: [].concat(pageTitle__script__toConsumableArray(document.querySelectorAll('.js-pageTitle__headline'))),
        fitties: [],
        fittyOptions: {
            minSize: 12,
            maxSize: 300,
            observeWindow: true
        }
    },

    initText: function initText() {
        this.cfg.fitties = Object(fitty_module["a" /* default */])('.js-pageTitle__headline');

        /* this.cfg.elements.forEach((item) => {
            fitty(item, this.cfg.fittyOptions);
        });
         this.resizeText(); */

        this.cfg.fitties.forEach(function (fit) {
            fit.fit();
        });

        // this.resizeText();
    },
    getStyle: function getStyle(el, cssprop) {
        if (el.currentStyle) {
            // IE & Opera
            return el.currentStyle[cssprop];
        } else if (document.defaultView && document.defaultView.getComputedStyle) {
            // Gecko & WebKit
            return document.defaultView.getComputedStyle(el, '')[cssprop];
        }
    },
    resizeText: function resizeText() {
        this.cfg.fitties.forEach(function (fit) {
            fit.unsubscribe();
        });

        this.cfg.fitties = Object(fitty_module["a" /* default */])('.js-pageTitle__headline');

        this.cfg.fitties.forEach(function (fit) {
            fit.fit();
        });

        // this.cfg.fitties.fitAll();

        /* this.cfg.elements.forEach((item) => {
            const fontSize = 12; // this.getStyle(item, 'fontSize');
            item.setAttribute('style',`line-height:${fontSize}px`);
        }); */
    },
    init: function init() {
        var _this = this;

        if (this.cfg.trigger.length > 0) {
            this.cfg.timeline.add(this.cfg.tweenObj);

            this.cfg.controller = new ScrollMagic_default.a.Controller();

            // build scene
            this.cfg.scene = new ScrollMagic_default.a.Scene({
                triggerElement: this.cfg.trigger,
                duration: '200%'
            }).addTo(this.cfg.controller).on('progress', function (event) {
                _this.cfg.timeline.seek(_this.cfg.timeline.duration * event.progress);
            });
        }

        window.addEventListener('load', function () {
            if (_this.cfg.elements.length > 0) {
                _this.initText();
                // this.resizeText();
            }
        });

        window.addEventListener('resize', function () {
            if (_this.cfg.elements.length > 0) {
                _this.resizeText();
            }
        });
    }
};

/* harmony default export */ var pageTitle__script = (pageTitle);
// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__(74);
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// CONCATENATED MODULE: ./___src/templates/_organisms/weather/_script.js
function weather__script__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/*
 * Description of what this file is for
 *
 * @package  craft3
 * @author Stefan Prosch [hello@stefanprosch.com]
 * weather
 */




var weather = {
    cfg: {
        wrapper: document.querySelector('.js-weather'),
        language: 'de',
        slider: '.js-forecast',
        sliderOptions: {
            cellAlign: 'left',
            contain: true,
            draggable: true,
            friction: 1,
            lazyLoad: 2,
            selectedAttraction: 0.1,
            groupCells: true,
            setGallerySize: true,
            imagesLoaded: true,
            prevNextButtons: false,
            pageDots: false,
            wrapAround: false
            // watchCSS: true

        }
    },

    init: function init() {
        var _this = this;

        window.addEventListener('load', function () {
            if (_this.cfg.wrapper) {
                _this.cfg.language = _this.cfg.wrapper.dataset.lang;
                /* eslint-disable */
                jquery_default.a.getJSON('https://api.openweathermap.org/data/2.5/weather?q=Plainfeld&units=metric&APPID=1e05badb113e8188d298e1f024d9119d&lang=' + _this.cfg.language, function (data) {
                    // this.cfg.wrapper.innerHTML += JSON.stringify(data);

                    // Manipulate Current Temperature
                    _this.cfg.wrapper.querySelector('.js-currentTemp').innerHTML = (Math.round(data.main.temp * 2) / 2 + '&deg;').replace('.', ',');
                    // Manipulate Current Description
                    _this.cfg.wrapper.querySelector('.js-currentDescription').innerHTML = '' + data.weather[0].description;
                    // Manipulate Current Location
                    _this.cfg.wrapper.querySelector('.js-currentLocation').innerHTML = '' + data.name;

                    // Manipulate Icon
                    _this.cfg.wrapper.querySelector('.js-currentIcon').innerHTML = '\n                      <svg class="a-svgSprite" viewbox="0 0 48 48">\n                        <use xlink:href="/assets/images/svg/sprite/sprite.svg#' + data.weather[0].id + '"></use>\n                      </svg>';
                });

                // Get Forecast
                jquery_default.a.getJSON('https://api.openweathermap.org/data/2.5/forecast?q=Plainfeld&units=metric&APPID=1e05badb113e8188d298e1f024d9119d&lang=' + _this.cfg.language, function (forecast) {
                    // this.cfg.wrapper.innerHTML += JSON.stringify(forecast);
                    var td = new Date();
                    var one_day = 1000 * 60 * 60 * 24;
                    var days = { 'de': ['Heute', 'Morgen'], 'en': ['Today', 'Tomorrow'] };
                    var weekdays = { 'de': ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'], 'en': ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'] };

                    forecast.list.forEach(function (item) {
                        var dt = new Date(item.dt * 1000);

                        // Convert both dates to milliseconds
                        var date1_ms = new Date(td.getFullYear(), td.getMonth(), td.getDate()).getTime();
                        var date2_ms = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate()).getTime();

                        // Calculate the difference in milliseconds
                        var difference_ms = date2_ms - date1_ms;

                        // Convert back to days and return
                        var diff = Math.round(difference_ms / one_day);

                        var output = diff <= 1 ? days[_this.cfg.language][diff] : weekdays[_this.cfg.language][dt.getDay()];

                        if (dt.getHours() == '10' || dt.getHours() == '16') {
                            _this.cfg.wrapper.querySelector('.js-forecast').innerHTML += '\n                                <div class="o-weather__slide" itemscope itemtype="http://schema.org/ImageObject">\n                                    <div class="o-weather__slideInner">\n                                        <div class="o-weather__forecastItem">\n                                            <div class="o-weather__forecastDay">\n                                                <span>' + output + '</span>\n                                                <span>' + (dt.getHours() < 9 ? '0' + dt.getHours() : dt.getHours()) + ':' + (dt.getMinutes() < 9 ? '0' + dt.getMinutes() : dt.getMinutes()) + '</span>\n                                            </div>\n                                            <div class="o-weather__forecastIcon">\n                                              <svg class="a-svgSprite" viewbox="0 0 48 48">\n                                                <use xlink:href="/assets/images/svg/sprite/sprite.svg#' + item.weather[0].id + '"></use>\n                                              </svg>\n                                            </div>\n                                            <div class="o-weather__forecastTemp">' + Math.round(item.main.temp * 2) / 2 + '&deg;C</div>\n                                        </div>\n                                    </div>\n                                </div>\n                            ';
                        }
                    });

                    var sliders = [].concat(weather__script__toConsumableArray(document.querySelectorAll(_this.cfg.slider)));
                    if (sliders) {
                        sliders.forEach(function (slider) {
                            var flkty = new js_default.a(slider, _this.cfg.sliderOptions);
                            flkty.resize();

                            setTimeout(function () {
                                flkty.resize();
                                slider.classList.add('is-ready');
                            }, 1000);
                        });
                    }
                });
                /* eslint-enable */
            }
        });
    }
};

/* harmony default export */ var weather__script = (weather);
// CONCATENATED MODULE: ./___src/templates/_organisms/imageTrack/_script.js
/**
 * SVG Icon
 */



var imageTrack = {
    cfg: {
        name: 'imageTrack',
        controller: '',
        trigger: document.querySelectorAll('.js-imageTrack'),
        path: anime_min_default.a.path('.js-imageTrack #track-motion')
    },

    init: function init() {
        var _this = this;

        window.addEventListener('load', function () {
            // Script
            /* var path = anime.path('.motion-path-demo #track-motion'); */

            anime_min_default()({
                targets: '#track-car',
                translateX: _this.cfg.path('x'),
                translateY: _this.cfg.path('y'),
                rotate: _this.cfg.path('angle'),
                easing: 'linear',
                duration: 16000,
                loop: true
            });
        });
    }
};

/* harmony default export */ var imageTrack__script = (imageTrack);
// CONCATENATED MODULE: ./___src/templates/_organisms/calendarList/_script.js
function calendarList__script__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Calendar List
 */

var calendarList = {
    cfg: {
        cell: '.js-tableCell'
    },

    init: function init() {
        var _this = this;

        window.addEventListener('load', function () {
            var cells = [].concat(calendarList__script__toConsumableArray(document.querySelectorAll(_this.cfg.cell)));

            if (cells) {
                cells.forEach(function (cell) {
                    var backgroundImages = cell.querySelectorAll('.o-calendarList__backgroundImage');
                    var privateImages = cell.querySelectorAll('.o-calendarList__backgroundImage--private');

                    if (backgroundImages.length > 1 && backgroundImages > privateImages) {
                        backgroundImages.forEach(function (backgroundImage) {
                            // eslint-disable-next-line
                            if (backgroundImage.classList.contains('o-calendarList__backgroundImage--private')) {
                                backgroundImage.style.display = 'none';
                            }
                        });
                    }
                });
            }
        });
    }
};

/* harmony default export */ var calendarList__script = (calendarList);
// CONCATENATED MODULE: ./___src/templates/_atoms/richText/_script.js
function richText__script__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * richText
 */

var richText = {
    cfg: {
        name: '.a-richText p',
        pTags: ''
    },

    init: function init() {
        this.cfg.pTags = [].concat(richText__script__toConsumableArray(document.querySelectorAll(this.cfg.name)));

        if (this.cfg.pTags) {
            this.cfg.pTags.forEach(function (pTag) {
                pTag.setAttribute('lang', document.documentElement.lang);
            });
        }
    }
};

/* harmony default export */ var richText__script = (richText);
// CONCATENATED MODULE: ./___src/templates/_molecules/faqList/_script.js
function faqList__script__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// import imageSlider from '../../_organisms/imageSlider/_script';

/**
 * faqList
 */

var faqList = {
    cfg: {
        name: 'faqList',
        triggers: [].concat(faqList__script__toConsumableArray(document.querySelectorAll('.js-faqTrigger'))),
        status: 'is-open'
    },

    // Toggle Content
    toggleAccordeon: function toggleAccordeon(event) {
        var _this = this;

        event.preventDefault();
        var target = event.currentTarget;
        var tabContent = document.getElementById(target.dataset.tab); // target.nextElementSibling;
        var allTabs = document.querySelectorAll('.js-faqContent');

        if (!target.classList.contains(this.cfg.status)) {
            allTabs.forEach(function (tab) {
                tab.classList.remove(_this.cfg.status);
            });
            this.cfg.triggers.forEach(function (trigger) {
                trigger.classList.remove(_this.cfg.status);
            });
            target.classList.add(this.cfg.status);
            tabContent.classList.add(this.cfg.status);

            // imageSlider.refreshSlider();
        } else {
            allTabs.forEach(function (tab) {
                tab.classList.remove(_this.cfg.status);
            });
            this.cfg.triggers.forEach(function (trigger) {
                trigger.classList.remove(_this.cfg.status);
            });
        }
    },
    init: function init() {
        var _this2 = this;

        this.cfg.triggers.forEach(function (trigger) {
            trigger.addEventListener('click', function (event) {
                _this2.toggleAccordeon(event);
            });
        });
    }
};

/* harmony default export */ var faqList__script = (faqList);
// CONCATENATED MODULE: ./___src/assets/js/partials/modules.js
/**
 * modules
 */













// import dataItem from '../../../templates/_molecules/dataItem/_script';
// import accordion    from '../../../templates/_templates/accordion/_main'
// import cookiebar    from '../../../templates/_modules/cookiebar/_main'
// import imageSlider  from '../../../templates/_modules/imageSlider/_main'
// import imageGallery from '../../../templates/_modules/imageGallery/_main'
// import navCategories from '../../../templates/_modules/navCategories/_main'

// Modules Array
var modulesArray = [_script, codeSnippet__script, imageSlider__script, imageGallery__script, appHeader__script, newsList__script, pageTitle__script, weather__script, imageTrack__script, calendarList__script, richText__script, faqList__script];

var modules = {
    // Modules
    Modules: function Modules() {
        if (modulesArray.length > 0 && modulesArray !== undefined) {
            modulesArray.forEach(function (module) {
                module.init();
            });
        }
    },
    init: function init() {
        this.Modules();
    }
};

/* harmony default export */ var partials_modules = (modules);
// CONCATENATED MODULE: ./___src/assets/js/app.js
/**
 * Bundle Scripts
 */

// Polyfills




































































































// Import Libs


// CSS Import




// Import Partials




var app_app = {
    toggleGrid: function toggleGrid() {
        var gridOverlay = document.querySelector('.o-gridOverlay');
        gridOverlay.classList.toggle('is-visible');
    },
    init: function init() {
        partials_scripts.init();
        partials_templates.init();
        partials_modules.init();

        var gridToggle = document.querySelector('.js-toggleGrid');
        if (gridToggle) {
            gridToggle.addEventListener('click', this.toggleGrid, false);
        }
    }
};

// Init App!
app_app.init();

/***/ }),

/***/ 220:
/***/ (function(module, exports) {

/* bling.js */

window.$ = document.querySelectorAll.bind(document);

Node.prototype.on = window.on = function (name, fn) {
    this.addEventListener(name, fn);
};

NodeList.prototype.__proto__ = Array.prototype;

NodeList.prototype.on = NodeList.prototype.addEventListener = function (name, fn) {
    this.forEach(function (elem, i) {
        elem.on(name, fn);
    });
};

/***/ }),

/***/ 221:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/* eslint-disable */
/* http://prismjs.com/download.html?themes=prism&languages=markup+css+clike+javascript+bash+css-extras+handlebars+json+markdown+php+php-extras+scss+twig&plugins=line-numbers+remove-initial-line-feed */

var _self = typeof window !== 'undefined' ? window // if in browser
: typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope ? self // if in worker
: {} // if in node js
;

/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 * MIT license http://www.opensource.org/licenses/mit-license.php/
 * @author Lea Verou http://lea.verou.me
 */

var Prism = function () {

    // Private helper vars
    var lang = /\blang(?:uage)?-(\w+)\b/i;
    var uniqueId = 0;

    var _ = _self.Prism = {
        manual: _self.Prism && _self.Prism.manual,
        disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
        util: {
            encode: function encode(tokens) {
                if (tokens instanceof Token) {
                    return new Token(tokens.type, _.util.encode(tokens.content), tokens.alias);
                } else if (_.util.type(tokens) === 'Array') {
                    return tokens.map(_.util.encode);
                } else {
                    return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
                }
            },

            type: function type(o) {
                return Object.prototype.toString.call(o).match(/\[object (\w+)\]/)[1];
            },

            objId: function objId(obj) {
                if (!obj['__id']) {
                    Object.defineProperty(obj, '__id', { value: ++uniqueId });
                }
                return obj['__id'];
            },

            // Deep clone a language definition (e.g. to extend it)
            clone: function clone(o) {
                var type = _.util.type(o);

                switch (type) {
                    case 'Object':
                        var clone = {};

                        for (var key in o) {
                            if (o.hasOwnProperty(key)) {
                                clone[key] = _.util.clone(o[key]);
                            }
                        }

                        return clone;

                    case 'Array':
                        return o.map(function (v) {
                            return _.util.clone(v);
                        });
                }

                return o;
            }
        },

        languages: {
            extend: function extend(id, redef) {
                var lang = _.util.clone(_.languages[id]);

                for (var key in redef) {
                    lang[key] = redef[key];
                }

                return lang;
            },

            /**
             * Insert a token before another token in a language literal
             * As this needs to recreate the object (we cannot actually insert before keys in object literals),
             * we cannot just provide an object, we need anobject and a key.
             * @param inside The key (or language id) of the parent
             * @param before The key to insert before. If not provided, the function appends instead.
             * @param insert Object with the key/value pairs to insert
             * @param root The object that contains `inside`. If equal to Prism.languages, it can be omitted.
             */
            insertBefore: function insertBefore(inside, before, insert, root) {
                root = root || _.languages;
                var grammar = root[inside];

                if (arguments.length == 2) {
                    insert = arguments[1];

                    for (var newToken in insert) {
                        if (insert.hasOwnProperty(newToken)) {
                            grammar[newToken] = insert[newToken];
                        }
                    }

                    return grammar;
                }

                var ret = {};

                for (var token in grammar) {

                    if (grammar.hasOwnProperty(token)) {

                        if (token == before) {

                            for (var newToken in insert) {

                                if (insert.hasOwnProperty(newToken)) {
                                    ret[newToken] = insert[newToken];
                                }
                            }
                        }

                        ret[token] = grammar[token];
                    }
                }

                // Update references in other language definitions
                _.languages.DFS(_.languages, function (key, value) {
                    if (value === root[inside] && key != inside) {
                        this[key] = ret;
                    }
                });

                return root[inside] = ret;
            },

            // Traverse a language definition with Depth First Search
            DFS: function DFS(o, callback, type, visited) {
                visited = visited || {};
                for (var i in o) {
                    if (o.hasOwnProperty(i)) {
                        callback.call(o, i, o[i], type || i);

                        if (_.util.type(o[i]) === 'Object' && !visited[_.util.objId(o[i])]) {
                            visited[_.util.objId(o[i])] = true;
                            _.languages.DFS(o[i], callback, null, visited);
                        } else if (_.util.type(o[i]) === 'Array' && !visited[_.util.objId(o[i])]) {
                            visited[_.util.objId(o[i])] = true;
                            _.languages.DFS(o[i], callback, i, visited);
                        }
                    }
                }
            }
        },
        plugins: {},

        highlightAll: function highlightAll(async, callback) {
            var env = {
                callback: callback,
                selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
            };

            _.hooks.run("before-highlightall", env);

            var elements = env.elements || document.querySelectorAll(env.selector);

            for (var i = 0, element; element = elements[i++];) {
                _.highlightElement(element, async === true, env.callback);
            }
        },

        highlightElement: function highlightElement(element, async, callback) {
            // Find language
            var language,
                grammar,
                parent = element;

            while (parent && !lang.test(parent.className)) {
                parent = parent.parentNode;
            }

            if (parent) {
                language = (parent.className.match(lang) || [, ''])[1].toLowerCase();
                grammar = _.languages[language];
            }

            // Set language on the element, if not present
            element.className = element.className.replace(lang, '').replace(/\s+/g, ' ') + ' language-' + language;

            if (element.parentNode) {
                // Set language on the parent, for styling
                parent = element.parentNode;

                if (/pre/i.test(parent.nodeName)) {
                    parent.className = parent.className.replace(lang, '').replace(/\s+/g, ' ') + ' language-' + language;
                }
            }

            var code = element.textContent;

            var env = {
                element: element,
                language: language,
                grammar: grammar,
                code: code
            };

            _.hooks.run('before-sanity-check', env);

            if (!env.code || !env.grammar) {
                if (env.code) {
                    _.hooks.run('before-highlight', env);
                    env.element.textContent = env.code;
                    _.hooks.run('after-highlight', env);
                }
                _.hooks.run('complete', env);
                return;
            }

            _.hooks.run('before-highlight', env);

            if (async && _self.Worker) {
                var worker = new Worker(_.filename);

                worker.onmessage = function (evt) {
                    env.highlightedCode = evt.data;

                    _.hooks.run('before-insert', env);

                    env.element.innerHTML = env.highlightedCode;

                    callback && callback.call(env.element);
                    _.hooks.run('after-highlight', env);
                    _.hooks.run('complete', env);
                };

                worker.postMessage(JSON.stringify({
                    language: env.language,
                    code: env.code,
                    immediateClose: true
                }));
            } else {
                env.highlightedCode = _.highlight(env.code, env.grammar, env.language);

                _.hooks.run('before-insert', env);

                env.element.innerHTML = env.highlightedCode;

                callback && callback.call(element);

                _.hooks.run('after-highlight', env);
                _.hooks.run('complete', env);
            }
        },

        highlight: function highlight(text, grammar, language) {
            var tokens = _.tokenize(text, grammar);
            return Token.stringify(_.util.encode(tokens), language);
        },

        matchGrammar: function matchGrammar(text, strarr, grammar, index, startPos, oneshot, target) {
            var Token = _.Token;

            for (var token in grammar) {
                if (!grammar.hasOwnProperty(token) || !grammar[token]) {
                    continue;
                }

                if (token == target) {
                    return;
                }

                var patterns = grammar[token];
                patterns = _.util.type(patterns) === "Array" ? patterns : [patterns];

                for (var j = 0; j < patterns.length; ++j) {
                    var pattern = patterns[j],
                        inside = pattern.inside,
                        lookbehind = !!pattern.lookbehind,
                        greedy = !!pattern.greedy,
                        lookbehindLength = 0,
                        alias = pattern.alias;

                    if (greedy && !pattern.pattern.global) {
                        // Without the global flag, lastIndex won't work
                        var flags = pattern.pattern.toString().match(/[imuy]*$/)[0];
                        pattern.pattern = RegExp(pattern.pattern.source, flags + "g");
                    }

                    pattern = pattern.pattern || pattern;

                    // Don’t cache length as it changes during the loop
                    for (var i = index, pos = startPos; i < strarr.length; pos += strarr[i].length, ++i) {

                        var str = strarr[i];

                        if (strarr.length > text.length) {
                            // Something went terribly wrong, ABORT, ABORT!
                            return;
                        }

                        if (str instanceof Token) {
                            continue;
                        }

                        pattern.lastIndex = 0;

                        var match = pattern.exec(str),
                            delNum = 1;

                        // Greedy patterns can override/remove up to two previously matched tokens
                        if (!match && greedy && i != strarr.length - 1) {
                            pattern.lastIndex = pos;
                            match = pattern.exec(text);
                            if (!match) {
                                break;
                            }

                            var from = match.index + (lookbehind ? match[1].length : 0),
                                to = match.index + match[0].length,
                                k = i,
                                p = pos;

                            for (var len = strarr.length; k < len && (p < to || !strarr[k].type && !strarr[k - 1].greedy); ++k) {
                                p += strarr[k].length;
                                // Move the index i to the element in strarr that is closest to from
                                if (from >= p) {
                                    ++i;
                                    pos = p;
                                }
                            }

                            /*
                             * If strarr[i] is a Token, then the match starts inside another Token, which is invalid
                             * If strarr[k - 1] is greedy we are in conflict with another greedy pattern
                             */
                            if (strarr[i] instanceof Token || strarr[k - 1].greedy) {
                                continue;
                            }

                            // Number of tokens to delete and replace with the new match
                            delNum = k - i;
                            str = text.slice(pos, p);
                            match.index -= pos;
                        }

                        if (!match) {
                            if (oneshot) {
                                break;
                            }

                            continue;
                        }

                        if (lookbehind) {
                            lookbehindLength = match[1].length;
                        }

                        var from = match.index + lookbehindLength,
                            match = match[0].slice(lookbehindLength),
                            to = from + match.length,
                            before = str.slice(0, from),
                            after = str.slice(to);

                        var args = [i, delNum];

                        if (before) {
                            ++i;
                            pos += before.length;
                            args.push(before);
                        }

                        var wrapped = new Token(token, inside ? _.tokenize(match, inside) : match, alias, match, greedy);

                        args.push(wrapped);

                        if (after) {
                            args.push(after);
                        }

                        Array.prototype.splice.apply(strarr, args);

                        if (delNum != 1) _.matchGrammar(text, strarr, grammar, i, pos, true, token);

                        if (oneshot) break;
                    }
                }
            }
        },

        tokenize: function tokenize(text, grammar, language) {
            var strarr = [text];

            var rest = grammar.rest;

            if (rest) {
                for (var token in rest) {
                    grammar[token] = rest[token];
                }

                delete grammar.rest;
            }

            _.matchGrammar(text, strarr, grammar, 0, 0, false);

            return strarr;
        },

        hooks: {
            all: {},

            add: function add(name, callback) {
                var hooks = _.hooks.all;

                hooks[name] = hooks[name] || [];

                hooks[name].push(callback);
            },

            run: function run(name, env) {
                var callbacks = _.hooks.all[name];

                if (!callbacks || !callbacks.length) {
                    return;
                }

                for (var i = 0, callback; callback = callbacks[i++];) {
                    callback(env);
                }
            }
        }
    };

    var Token = _.Token = function (type, content, alias, matchedStr, greedy) {
        this.type = type;
        this.content = content;
        this.alias = alias;
        // Copy of the full string this token was created from
        this.length = (matchedStr || "").length | 0;
        this.greedy = !!greedy;
    };

    Token.stringify = function (o, language, parent) {
        if (typeof o == 'string') {
            return o;
        }

        if (_.util.type(o) === 'Array') {
            return o.map(function (element) {
                return Token.stringify(element, language, o);
            }).join('');
        }

        var env = {
            type: o.type,
            content: Token.stringify(o.content, language, parent),
            tag: 'span',
            classes: ['token', o.type],
            attributes: {},
            language: language,
            parent: parent
        };

        if (o.alias) {
            var aliases = _.util.type(o.alias) === 'Array' ? o.alias : [o.alias];
            Array.prototype.push.apply(env.classes, aliases);
        }

        _.hooks.run('wrap', env);

        var attributes = Object.keys(env.attributes).map(function (name) {
            return name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
        }).join(' ');

        return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + (attributes ? ' ' + attributes : '') + '>' + env.content + '</' + env.tag + '>';
    };

    if (!_self.document) {
        if (!_self.addEventListener) {
            // in Node.js
            return _self.Prism;
        }

        if (!_.disableWorkerMessageHandler) {
            // In worker
            _self.addEventListener('message', function (evt) {
                var message = JSON.parse(evt.data),
                    lang = message.language,
                    code = message.code,
                    immediateClose = message.immediateClose;

                _self.postMessage(_.highlight(code, _.languages[lang], lang));
                if (immediateClose) {
                    _self.close();
                }
            }, false);
        }

        return _self.Prism;
    }

    //Get current script and highlight
    var script = document.currentScript || [].slice.call(document.getElementsByTagName("script")).pop();

    if (script) {
        _.filename = script.src;

        if (!_.manual && !script.hasAttribute('data-manual')) {
            if (document.readyState !== "loading") {
                if (window.requestAnimationFrame) {
                    window.requestAnimationFrame(_.highlightAll);
                } else {
                    window.setTimeout(_.highlightAll, 16);
                }
            } else {
                document.addEventListener('DOMContentLoaded', _.highlightAll);
            }
        }
    }

    return _self.Prism;
}();

if (typeof module !== 'undefined' && module.exports) {
    module.exports = Prism;
}

// hack for components to work correctly in node.js
if (typeof global !== 'undefined') {
    global.Prism = Prism;
}
;
Prism.languages.markup = {
    'comment': /<!--[\s\S]*?-->/,
    'prolog': /<\?[\s\S]+?\?>/,
    'doctype': /<!DOCTYPE[\s\S]+?>/i,
    'cdata': /<!\[CDATA\[[\s\S]*?]]>/i,
    'tag': {
        pattern: /<\/?(?!\d)[^\s>\/=$<]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/i,
        inside: {
            'tag': {
                pattern: /^<\/?[^\s>\/]+/i,
                inside: {
                    'punctuation': /^<\/?/,
                    'namespace': /^[^\s>\/:]+:/
                }
            },
            'attr-value': {
                pattern: /=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+)/i,
                inside: {
                    'punctuation': [/^=/, {
                        pattern: /(^|[^\\])["']/,
                        lookbehind: true
                    }]
                }
            },
            'punctuation': /\/?>/,
            'attr-name': {
                pattern: /[^\s>\/]+/,
                inside: {
                    'namespace': /^[^\s>\/:]+:/
                }
            }

        }
    },
    'entity': /&#?[\da-z]{1,8};/i
};

Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] = Prism.languages.markup['entity'];

// Plugin to make entity title show the real entity, idea by Roman Komarov
Prism.hooks.add('wrap', function (env) {

    if (env.type === 'entity') {
        env.attributes['title'] = env.content.replace(/&amp;/, '&');
    }
});

Prism.languages.xml = Prism.languages.markup;
Prism.languages.html = Prism.languages.markup;
Prism.languages.mathml = Prism.languages.markup;
Prism.languages.svg = Prism.languages.markup;

Prism.languages.css = {
    'comment': /\/\*[\s\S]*?\*\//,
    'atrule': {
        pattern: /@[\w-]+?.*?(?:;|(?=\s*\{))/i,
        inside: {
            'rule': /@[\w-]+/
            // See rest below
        }
    },
    'url': /url\((?:(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1|.*?)\)/i,
    'selector': /[^{}\s][^{};]*?(?=\s*\{)/,
    'string': {
        pattern: /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    'property': /[\w-]+(?=\s*:)/i,
    'important': /\B!important\b/i,
    'function': /[-a-z0-9]+(?=\()/i,
    'punctuation': /[(){};:]/
};

Prism.languages.css['atrule'].inside.rest = Prism.util.clone(Prism.languages.css);

if (Prism.languages.markup) {
    Prism.languages.insertBefore('markup', 'tag', {
        'style': {
            pattern: /(<style[\s\S]*?>)[\s\S]*?(?=<\/style>)/i,
            lookbehind: true,
            inside: Prism.languages.css,
            alias: 'language-css'
        }
    });

    Prism.languages.insertBefore('inside', 'attr-value', {
        'style-attr': {
            pattern: /\s*style=("|')(?:\\[\s\S]|(?!\1)[^\\])*\1/i,
            inside: {
                'attr-name': {
                    pattern: /^\s*style/i,
                    inside: Prism.languages.markup.tag.inside
                },
                'punctuation': /^\s*=\s*['"]|['"]\s*$/,
                'attr-value': {
                    pattern: /.+/i,
                    inside: Prism.languages.css
                }
            },
            alias: 'language-css'
        }
    }, Prism.languages.markup.tag);
};
Prism.languages.clike = {
    'comment': [{
        pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
        lookbehind: true
    }, {
        pattern: /(^|[^\\:])\/\/.*/,
        lookbehind: true
    }],
    'string': {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    'class-name': {
        pattern: /((?:\b(?:class|interface|extends|implements|trait|instanceof|new)\s+)|(?:catch\s+\())[\w.\\]+/i,
        lookbehind: true,
        inside: {
            punctuation: /[.\\]/
        }
    },
    'keyword': /\b(?:if|else|while|do|for|return|in|instanceof|function|new|try|throw|catch|finally|null|break|continue)\b/,
    'boolean': /\b(?:true|false)\b/,
    'function': /[a-z0-9_]+(?=\()/i,
    'number': /\b-?(?:0x[\da-f]+|\d*\.?\d+(?:e[+-]?\d+)?)\b/i,
    'operator': /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&?|\|\|?|\?|\*|\/|~|\^|%/,
    'punctuation': /[{}[\];(),.:]/
};

Prism.languages.javascript = Prism.languages.extend('clike', {
    'keyword': /\b(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|var|void|while|with|yield)\b/,
    'number': /\b-?(?:0[xX][\dA-Fa-f]+|0[bB][01]+|0[oO][0-7]+|\d*\.?\d+(?:[Ee][+-]?\d+)?|NaN|Infinity)\b/,
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    'function': /[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*(?=\s*\()/i,
    'operator': /-[-=]?|\+[+=]?|!=?=?|<<?=?|>>?>?=?|=(?:==?|>)?|&[&=]?|\|[|=]?|\*\*?=?|\/=?|~|\^=?|%=?|\?|\.{3}/
});

Prism.languages.insertBefore('javascript', 'keyword', {
    'regex': {
        pattern: /(^|[^/])\/(?!\/)(\[[^\]\r\n]+]|\\.|[^/\\\[\r\n])+\/[gimyu]{0,5}(?=\s*($|[\r\n,.;})]))/,
        lookbehind: true,
        greedy: true
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    'function-variable': {
        pattern: /[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*(?=\s*=\s*(?:function\b|(?:\([^()]*\)|[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)\s*=>))/i,
        alias: 'function'
    }
});

Prism.languages.insertBefore('javascript', 'string', {
    'template-string': {
        pattern: /`(?:\\[\s\S]|[^\\`])*`/,
        greedy: true,
        inside: {
            'interpolation': {
                pattern: /\$\{[^}]+\}/,
                inside: {
                    'interpolation-punctuation': {
                        pattern: /^\$\{|\}$/,
                        alias: 'punctuation'
                    },
                    rest: Prism.languages.javascript
                }
            },
            'string': /[\s\S]+/
        }
    }
});

if (Prism.languages.markup) {
    Prism.languages.insertBefore('markup', 'tag', {
        'script': {
            pattern: /(<script[\s\S]*?>)[\s\S]*?(?=<\/script>)/i,
            lookbehind: true,
            inside: Prism.languages.javascript,
            alias: 'language-javascript'
        }
    });
}

Prism.languages.js = Prism.languages.javascript;

(function (Prism) {
    var insideString = {
        variable: [
        // Arithmetic Environment
        {
            pattern: /\$?\(\([\s\S]+?\)\)/,
            inside: {
                // If there is a $ sign at the beginning highlight $(( and )) as variable
                variable: [{
                    pattern: /(^\$\(\([\s\S]+)\)\)/,
                    lookbehind: true
                }, /^\$\(\(/],
                number: /\b-?(?:0x[\dA-Fa-f]+|\d*\.?\d+(?:[Ee]-?\d+)?)\b/,
                // Operators according to https://www.gnu.org/software/bash/manual/bashref.html#Shell-Arithmetic
                operator: /--?|-=|\+\+?|\+=|!=?|~|\*\*?|\*=|\/=?|%=?|<<=?|>>=?|<=?|>=?|==?|&&?|&=|\^=?|\|\|?|\|=|\?|:/,
                // If there is no $ sign at the beginning highlight (( and )) as punctuation
                punctuation: /\(\(?|\)\)?|,|;/
            }
        },
        // Command Substitution
        {
            pattern: /\$\([^)]+\)|`[^`]+`/,
            inside: {
                variable: /^\$\(|^`|\)$|`$/
            }
        }, /\$(?:[\w#?*!@]+|\{[^}]+\})/i]
    };

    Prism.languages.bash = {
        'shebang': {
            pattern: /^#!\s*\/bin\/bash|^#!\s*\/bin\/sh/,
            alias: 'important'
        },
        'comment': {
            pattern: /(^|[^"{\\])#.*/,
            lookbehind: true
        },
        'string': [
        //Support for Here-Documents https://en.wikipedia.org/wiki/Here_document
        {
            pattern: /((?:^|[^<])<<\s*)["']?(\w+?)["']?\s*\r?\n(?:[\s\S])*?\r?\n\2/,
            lookbehind: true,
            greedy: true,
            inside: insideString
        }, {
            pattern: /(["'])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
            greedy: true,
            inside: insideString
        }],
        'variable': insideString.variable,
        // Originally based on http://ss64.com/bash/
        'function': {
            pattern: /(^|[\s;|&])(?:alias|apropos|apt-get|aptitude|aspell|awk|basename|bash|bc|bg|builtin|bzip2|cal|cat|cd|cfdisk|chgrp|chmod|chown|chroot|chkconfig|cksum|clear|cmp|comm|command|cp|cron|crontab|csplit|cut|date|dc|dd|ddrescue|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|du|egrep|eject|enable|env|ethtool|eval|exec|expand|expect|export|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|getopts|git|grep|groupadd|groupdel|groupmod|groups|gzip|hash|head|help|hg|history|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|jobs|join|kill|killall|less|link|ln|locate|logname|logout|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|make|man|mkdir|mkfifo|mkisofs|mknod|more|most|mount|mtools|mtr|mv|mmv|nano|netstat|nice|nl|nohup|notify-send|npm|nslookup|open|op|passwd|paste|pathchk|ping|pkill|popd|pr|printcap|printenv|printf|ps|pushd|pv|pwd|quota|quotacheck|quotactl|ram|rar|rcp|read|readarray|readonly|reboot|rename|renice|remsync|rev|rm|rmdir|rsync|screen|scp|sdiff|sed|seq|service|sftp|shift|shopt|shutdown|sleep|slocate|sort|source|split|ssh|stat|strace|su|sudo|sum|suspend|sync|tail|tar|tee|test|time|timeout|times|touch|top|traceroute|trap|tr|tsort|tty|type|ulimit|umask|umount|unalias|uname|unexpand|uniq|units|unrar|unshar|uptime|useradd|userdel|usermod|users|uuencode|uudecode|v|vdir|vi|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yes|zip)(?=$|[\s;|&])/,
            lookbehind: true
        },
        'keyword': {
            pattern: /(^|[\s;|&])(?:let|:|\.|if|then|else|elif|fi|for|break|continue|while|in|case|function|select|do|done|until|echo|exit|return|set|declare)(?=$|[\s;|&])/,
            lookbehind: true
        },
        'boolean': {
            pattern: /(^|[\s;|&])(?:true|false)(?=$|[\s;|&])/,
            lookbehind: true
        },
        'operator': /&&?|\|\|?|==?|!=?|<<<?|>>|<=?|>=?|=~/,
        'punctuation': /\$?\(\(?|\)\)?|\.\.|[{}[\];]/
    };

    var inside = insideString.variable[1].inside;
    inside['function'] = Prism.languages.bash['function'];
    inside.keyword = Prism.languages.bash.keyword;
    inside.boolean = Prism.languages.bash.boolean;
    inside.operator = Prism.languages.bash.operator;
    inside.punctuation = Prism.languages.bash.punctuation;
})(Prism);

Prism.languages.css.selector = {
    pattern: /[^{}\s][^{}]*(?=\s*\{)/,
    inside: {
        'pseudo-element': /:(?:after|before|first-letter|first-line|selection)|::[-\w]+/,
        'pseudo-class': /:[-\w]+(?:\(.*\))?/,
        'class': /\.[-:.\w]+/,
        'id': /#[-:.\w]+/,
        'attribute': /\[[^\]]+\]/
    }
};

Prism.languages.insertBefore('css', 'function', {
    'hexcode': /#[\da-f]{3,8}/i,
    'entity': /\\[\da-f]{1,8}/i,
    'number': /[\d%.]+/
});
(function (Prism) {

    var handlebars_pattern = /\{\{\{[\s\S]+?\}\}\}|\{\{[\s\S]+?\}\}/;

    Prism.languages.handlebars = Prism.languages.extend('markup', {
        'handlebars': {
            pattern: handlebars_pattern,
            inside: {
                'delimiter': {
                    pattern: /^\{\{\{?|\}\}\}?$/i,
                    alias: 'punctuation'
                },
                'string': /(["'])(?:\\.|(?!\1)[^\\\r\n])*\1/,
                'number': /\b-?(?:0x[\dA-Fa-f]+|\d*\.?\d+(?:[Ee][+-]?\d+)?)\b/,
                'boolean': /\b(?:true|false)\b/,
                'block': {
                    pattern: /^(\s*~?\s*)[#\/]\S+?(?=\s*~?\s*$|\s)/i,
                    lookbehind: true,
                    alias: 'keyword'
                },
                'brackets': {
                    pattern: /\[[^\]]+\]/,
                    inside: {
                        punctuation: /\[|\]/,
                        variable: /[\s\S]+/
                    }
                },
                'punctuation': /[!"#%&'()*+,.\/;<=>@\[\\\]^`{|}~]/,
                'variable': /[^!"#%&'()*+,.\/;<=>@\[\\\]^`{|}~\s]+/
            }
        }
    });

    // Comments are inserted at top so that they can
    // surround markup
    Prism.languages.insertBefore('handlebars', 'tag', {
        'handlebars-comment': {
            pattern: /\{\{![\s\S]*?\}\}/,
            alias: ['handlebars', 'comment']
        }
    });

    // Tokenize all inline Handlebars expressions that are wrapped in {{ }} or {{{ }}}
    // This allows for easy Handlebars + markup highlighting
    Prism.hooks.add('before-highlight', function (env) {
        if (env.language !== 'handlebars') {
            return;
        }

        env.tokenStack = [];

        env.backupCode = env.code;
        env.code = env.code.replace(handlebars_pattern, function (match) {
            var i = env.tokenStack.length;
            // Check for existing strings
            while (env.backupCode.indexOf('___HANDLEBARS' + i + '___') !== -1) {
                ++i;
            } // Create a sparse array
            env.tokenStack[i] = match;

            return '___HANDLEBARS' + i + '___';
        });
    });

    // Restore env.code for other plugins (e.g. line-numbers)
    Prism.hooks.add('before-insert', function (env) {
        if (env.language === 'handlebars') {
            env.code = env.backupCode;
            delete env.backupCode;
        }
    });

    // Re-insert the tokens after highlighting
    // and highlight them with defined grammar
    Prism.hooks.add('after-highlight', function (env) {
        if (env.language !== 'handlebars') {
            return;
        }

        for (var i = 0, keys = Object.keys(env.tokenStack); i < keys.length; ++i) {
            var k = keys[i];
            var t = env.tokenStack[k];

            // The replace prevents $$, $&, $`, $', $n, $nn from being interpreted as special patterns
            env.highlightedCode = env.highlightedCode.replace('___HANDLEBARS' + k + '___', Prism.highlight(t, env.grammar, 'handlebars').replace(/\$/g, '$$$$'));
        }

        env.element.innerHTML = env.highlightedCode;
    });
})(Prism);

Prism.languages.json = {
    'property': /"(?:\\.|[^\\"\r\n])*"(?=\s*:)/i,
    'string': {
        pattern: /"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
        greedy: true
    },
    'number': /\b-?(?:0x[\dA-Fa-f]+|\d*\.?\d+(?:[Ee][+-]?\d+)?)\b/,
    'punctuation': /[{}[\]);,]/,
    'operator': /:/g,
    'boolean': /\b(?:true|false)\b/i,
    'null': /\bnull\b/i
};

Prism.languages.jsonp = Prism.languages.json;

Prism.languages.markdown = Prism.languages.extend('markup', {});
Prism.languages.insertBefore('markdown', 'prolog', {
    'blockquote': {
        // > ...
        pattern: /^>(?:[\t ]*>)*/m,
        alias: 'punctuation'
    },
    'code': [{
        // Prefixed by 4 spaces or 1 tab
        pattern: /^(?: {4}|\t).+/m,
        alias: 'keyword'
    }, {
        // `code`
        // ``code``
        pattern: /``.+?``|`[^`\n]+`/,
        alias: 'keyword'
    }],
    'title': [{
        // title 1
        // =======

        // title 2
        // -------
        pattern: /\w+.*(?:\r?\n|\r)(?:==+|--+)/,
        alias: 'important',
        inside: {
            punctuation: /==+$|--+$/
        }
    }, {
        // # title 1
        // ###### title 6
        pattern: /(^\s*)#+.+/m,
        lookbehind: true,
        alias: 'important',
        inside: {
            punctuation: /^#+|#+$/
        }
    }],
    'hr': {
        // ***
        // ---
        // * * *
        // -----------
        pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
        lookbehind: true,
        alias: 'punctuation'
    },
    'list': {
        // * item
        // + item
        // - item
        // 1. item
        pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
        lookbehind: true,
        alias: 'punctuation'
    },
    'url-reference': {
        // [id]: http://example.com "Optional title"
        // [id]: http://example.com 'Optional title'
        // [id]: http://example.com (Optional title)
        // [id]: <http://example.com> "Optional title"
        pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
        inside: {
            'variable': {
                pattern: /^(!?\[)[^\]]+/,
                lookbehind: true
            },
            'string': /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
            'punctuation': /^[\[\]!:]|[<>]/
        },
        alias: 'url'
    },
    'bold': {
        // **strong**
        // __strong__

        // Allow only one line break
        pattern: /(^|[^\\])(\*\*|__)(?:(?:\r?\n|\r)(?!\r?\n|\r)|.)+?\2/,
        lookbehind: true,
        inside: {
            'punctuation': /^\*\*|^__|\*\*$|__$/
        }
    },
    'italic': {
        // *em*
        // _em_

        // Allow only one line break
        pattern: /(^|[^\\])([*_])(?:(?:\r?\n|\r)(?!\r?\n|\r)|.)+?\2/,
        lookbehind: true,
        inside: {
            'punctuation': /^[*_]|[*_]$/
        }
    },
    'url': {
        // [example](http://example.com "Optional title")
        // [example] [id]
        pattern: /!?\[[^\]]+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)| ?\[[^\]\n]*\])/,
        inside: {
            'variable': {
                pattern: /(!?\[)[^\]]+(?=\]$)/,
                lookbehind: true
            },
            'string': {
                pattern: /"(?:\\.|[^"\\])*"(?=\)$)/
            }
        }
    }
});

Prism.languages.markdown['bold'].inside['url'] = Prism.util.clone(Prism.languages.markdown['url']);
Prism.languages.markdown['italic'].inside['url'] = Prism.util.clone(Prism.languages.markdown['url']);
Prism.languages.markdown['bold'].inside['italic'] = Prism.util.clone(Prism.languages.markdown['italic']);
Prism.languages.markdown['italic'].inside['bold'] = Prism.util.clone(Prism.languages.markdown['bold']);
/**
 * Original by Aaron Harun: http://aahacreative.com/2012/07/31/php-syntax-highlighting-prism/
 * Modified by Miles Johnson: http://milesj.me
 *
 * Supports the following:
 * 		- Extends clike syntax
 * 		- Support for PHP 5.3+ (namespaces, traits, generators, etc)
 * 		- Smarter constant and function matching
 *
 * Adds the following new token classes:
 * 		constant, delimiter, variable, function, package
 */

Prism.languages.php = Prism.languages.extend('clike', {
    'keyword': /\b(?:and|or|xor|array|as|break|case|cfunction|class|const|continue|declare|default|die|do|else|elseif|enddeclare|endfor|endforeach|endif|endswitch|endwhile|extends|for|foreach|function|include|include_once|global|if|new|return|static|switch|use|require|require_once|var|while|abstract|interface|public|implements|private|protected|parent|throw|null|echo|print|trait|namespace|final|yield|goto|instanceof|finally|try|catch)\b/i,
    'constant': /\b[A-Z0-9_]{2,}\b/,
    'comment': {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
        lookbehind: true
    }
});

// Shell-like comments are matched after strings, because they are less
// common than strings containing hashes...
Prism.languages.insertBefore('php', 'class-name', {
    'shell-comment': {
        pattern: /(^|[^\\])#.*/,
        lookbehind: true,
        alias: 'comment'
    }
});

Prism.languages.insertBefore('php', 'keyword', {
    'delimiter': {
        pattern: /\?>|<\?(?:php|=)?/i,
        alias: 'important'
    },
    'variable': /\$\w+\b/i,
    'package': {
        pattern: /(\\|namespace\s+|use\s+)[\w\\]+/,
        lookbehind: true,
        inside: {
            punctuation: /\\/
        }
    }
});

// Must be defined after the function pattern
Prism.languages.insertBefore('php', 'operator', {
    'property': {
        pattern: /(->)[\w]+/,
        lookbehind: true
    }
});

// Add HTML support if the markup language exists
if (Prism.languages.markup) {

    // Tokenize all inline PHP blocks that are wrapped in <?php ?>
    // This allows for easy PHP + markup highlighting
    Prism.hooks.add('before-highlight', function (env) {
        if (env.language !== 'php' || !/(?:<\?php|<\?)/ig.test(env.code)) {
            return;
        }

        env.tokenStack = [];

        env.backupCode = env.code;
        env.code = env.code.replace(/(?:<\?php|<\?)[\s\S]*?(?:\?>|$)/ig, function (match) {
            var i = env.tokenStack.length;
            // Check for existing strings
            while (env.backupCode.indexOf('___PHP' + i + '___') !== -1) {
                ++i;
            } // Create a sparse array
            env.tokenStack[i] = match;

            return '___PHP' + i + '___';
        });

        // Switch the grammar to markup
        env.grammar = Prism.languages.markup;
    });

    // Restore env.code for other plugins (e.g. line-numbers)
    Prism.hooks.add('before-insert', function (env) {
        if (env.language === 'php' && env.backupCode) {
            env.code = env.backupCode;
            delete env.backupCode;
        }
    });

    // Re-insert the tokens after highlighting
    Prism.hooks.add('after-highlight', function (env) {
        if (env.language !== 'php' || !env.tokenStack) {
            return;
        }

        // Switch the grammar back
        env.grammar = Prism.languages.php;

        for (var i = 0, keys = Object.keys(env.tokenStack); i < keys.length; ++i) {
            var k = keys[i];
            var t = env.tokenStack[k];

            // The replace prevents $$, $&, $`, $', $n, $nn from being interpreted as special patterns
            env.highlightedCode = env.highlightedCode.replace('___PHP' + k + '___', "<span class=\"token php language-php\">" + Prism.highlight(t, env.grammar, 'php').replace(/\$/g, '$$$$') + "</span>");
        }

        env.element.innerHTML = env.highlightedCode;
    });
}
;
Prism.languages.insertBefore('php', 'variable', {
    'this': /\$this\b/,
    'global': /\$(?:_(?:SERVER|GET|POST|FILES|REQUEST|SESSION|ENV|COOKIE)|GLOBALS|HTTP_RAW_POST_DATA|argc|argv|php_errormsg|http_response_header)\b/,
    'scope': {
        pattern: /\b[\w\\]+::/,
        inside: {
            keyword: /static|self|parent/,
            punctuation: /::|\\/
        }
    }
});
Prism.languages.scss = Prism.languages.extend('css', {
    'comment': {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
        lookbehind: true
    },
    'atrule': {
        pattern: /@[\w-]+(?:\([^()]+\)|[^(])*?(?=\s+[{;])/,
        inside: {
            'rule': /@[\w-]+/
            // See rest below
        }
    },
    // url, compassified
    'url': /(?:[-a-z]+-)*url(?=\()/i,
    // CSS selector regex is not appropriate for Sass
    // since there can be lot more things (var, @ directive, nesting..)
    // a selector must start at the end of a property or after a brace (end of other rules or nesting)
    // it can contain some characters that aren't used for defining rules or end of selector, & (parent selector), or interpolated variable
    // the end of a selector is found when there is no rules in it ( {} or {\s}) or if there is a property (because an interpolated var
    // can "pass" as a selector- e.g: proper#{$erty})
    // this one was hard to do, so please be careful if you edit this one :)
    'selector': {
        // Initial look-ahead is used to prevent matching of blank selectors
        pattern: /(?=\S)[^@;{}()]?(?:[^@;{}()]|&|#\{\$[-\w]+\})+(?=\s*\{(?:\}|\s|[^}]+[:{][^}]+))/m,
        inside: {
            'parent': {
                pattern: /&/,
                alias: 'important'
            },
            'placeholder': /%[-\w]+/,
            'variable': /\$[-\w]+|#\{\$[-\w]+\}/
        }
    }
});

Prism.languages.insertBefore('scss', 'atrule', {
    'keyword': [/@(?:if|else(?: if)?|for|each|while|import|extend|debug|warn|mixin|include|function|return|content)/i, {
        pattern: /( +)(?:from|through)(?= )/,
        lookbehind: true
    }]
});

Prism.languages.scss.property = {
    pattern: /(?:[\w-]|\$[-\w]+|#\{\$[-\w]+\})+(?=\s*:)/i,
    inside: {
        'variable': /\$[-\w]+|#\{\$[-\w]+\}/
    }
};

Prism.languages.insertBefore('scss', 'important', {
    // var and interpolated vars
    'variable': /\$[-\w]+|#\{\$[-\w]+\}/
});

Prism.languages.insertBefore('scss', 'function', {
    'placeholder': {
        pattern: /%[-\w]+/,
        alias: 'selector'
    },
    'statement': {
        pattern: /\B!(?:default|optional)\b/i,
        alias: 'keyword'
    },
    'boolean': /\b(?:true|false)\b/,
    'null': /\bnull\b/,
    'operator': {
        pattern: /(\s)(?:[-+*\/%]|[=!]=|<=?|>=?|and|or|not)(?=\s)/,
        lookbehind: true
    }
});

Prism.languages.scss['atrule'].inside.rest = Prism.util.clone(Prism.languages.scss);
Prism.languages.twig = {
    'comment': /\{#[\s\S]*?#\}/,
    'tag': {
        pattern: /\{\{[\s\S]*?\}\}|\{%[\s\S]*?%\}/,
        inside: {
            'ld': {
                pattern: /^(?:\{\{-?|\{%-?\s*\w+)/,
                inside: {
                    'punctuation': /^(?:\{\{|\{%)-?/,
                    'keyword': /\w+/
                }
            },
            'rd': {
                pattern: /-?(?:%\}|\}\})$/,
                inside: {
                    'punctuation': /.*/
                }
            },
            'string': {
                pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
                inside: {
                    'punctuation': /^['"]|['"]$/
                }
            },
            'keyword': /\b(?:even|if|odd)\b/,
            'boolean': /\b(?:true|false|null)\b/,
            'number': /\b-?(?:0x[\dA-Fa-f]+|\d*\.?\d+(?:[Ee][-+]?\d+)?)\b/,
            'operator': [{
                pattern: /(\s)(?:and|b-and|b-xor|b-or|ends with|in|is|matches|not|or|same as|starts with)(?=\s)/,
                lookbehind: true
            }, /[=<>]=?|!=|\*\*?|\/\/?|\?:?|[-+~%|]/],
            'property': /\b[a-zA-Z_]\w*\b/,
            'punctuation': /[()\[\]{}:.,]/
        }
    },

    // The rest can be parsed as HTML
    'other': {
        // We want non-blank matches
        pattern: /\S(?:[\s\S]*\S)?/,
        inside: Prism.languages.markup
    }
};

(function () {

    if (typeof self === 'undefined' || !self.Prism || !self.document) {
        return;
    }

    /**
     * Class name for <pre> which is activating the plugin
     * @type {String}
     */
    var PLUGIN_CLASS = 'line-numbers';

    /**
     * Resizes line numbers spans according to height of line of code
     * @param  {Element} element <pre> element
     */
    var _resizeElement = function _resizeElement(element) {
        var codeStyles = getStyles(element);
        var whiteSpace = codeStyles['white-space'];

        if (whiteSpace === 'pre-wrap' || whiteSpace === 'pre-line') {
            var codeElement = element.querySelector('code');
            var lineNumbersWrapper = element.querySelector('.line-numbers-rows');
            var lineNumberSizer = element.querySelector('.line-numbers-sizer');
            var codeLines = element.textContent.split('\n');

            if (!lineNumberSizer) {
                lineNumberSizer = document.createElement('span');
                lineNumberSizer.className = 'line-numbers-sizer';

                codeElement.appendChild(lineNumberSizer);
            }

            lineNumberSizer.style.display = 'block';

            codeLines.forEach(function (line, lineNumber) {
                lineNumberSizer.textContent = line || '\n';
                var lineSize = lineNumberSizer.getBoundingClientRect().height;
                lineNumbersWrapper.children[lineNumber].style.height = lineSize + 'px';
            });

            lineNumberSizer.textContent = '';
            lineNumberSizer.style.display = 'none';
        }
    };

    /**
     * Returns style declarations for the element
     * @param {Element} element
     */
    var getStyles = function getStyles(element) {
        if (!element) {
            return null;
        }

        return window.getComputedStyle ? getComputedStyle(element) : element.currentStyle || null;
    };

    window.addEventListener('resize', function () {
        Array.prototype.forEach.call(document.querySelectorAll('pre.' + PLUGIN_CLASS), _resizeElement);
    });

    Prism.hooks.add('complete', function (env) {
        if (!env.code) {
            return;
        }

        // works only for <code> wrapped inside <pre> (not inline)
        var pre = env.element.parentNode;
        var clsReg = /\s*\bline-numbers\b\s*/;
        if (!pre || !/pre/i.test(pre.nodeName) ||
        // Abort only if nor the <pre> nor the <code> have the class
        !clsReg.test(pre.className) && !clsReg.test(env.element.className)) {
            return;
        }

        if (env.element.querySelector(".line-numbers-rows")) {
            // Abort if line numbers already exists
            return;
        }

        if (clsReg.test(env.element.className)) {
            // Remove the class "line-numbers" from the <code>
            env.element.className = env.element.className.replace(clsReg, ' ');
        }
        if (!clsReg.test(pre.className)) {
            // Add the class "line-numbers" to the <pre>
            pre.className += ' line-numbers';
        }

        var match = env.code.match(/\n(?!$)/g);
        var linesNum = match ? match.length + 1 : 1;
        var lineNumbersWrapper;

        var lines = new Array(linesNum + 1);
        lines = lines.join('<span></span>');

        lineNumbersWrapper = document.createElement('span');
        lineNumbersWrapper.setAttribute('aria-hidden', 'true');
        lineNumbersWrapper.className = 'line-numbers-rows';
        lineNumbersWrapper.innerHTML = lines;

        if (pre.hasAttribute('data-start')) {
            pre.style.counterReset = 'linenumber ' + (parseInt(pre.getAttribute('data-start'), 10) - 1);
        }

        env.element.appendChild(lineNumbersWrapper);

        _resizeElement(pre);
    });
})();
(function () {

    if (typeof self === 'undefined' || !self.Prism || !self.document) {
        return;
    }

    Prism.hooks.add('before-sanity-check', function (env) {
        if (env.code) {
            var pre = env.element.parentNode;
            var clsReg = /\s*\bkeep-initial-line-feed\b\s*/;
            if (pre && pre.nodeName.toLowerCase() === 'pre' &&
            // Apply only if nor the <pre> or the <code> have the class
            !clsReg.test(pre.className) && !clsReg.test(env.element.className)) {
                env.code = env.code.replace(/^(?:\r?\n|\r)/, '');
            }
        }
    });
})();
/* eslint-enable */
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(104)))

/***/ }),

/***/ 228:
/***/ (function(module, exports) {

// import FontFaceObserver from 'fontfaceobserver'

// Disable if you use WebFonts
document.documentElement.className += " wf-loaded";

/**
 * Check if the User already visited the site and the Fonts were loaded
 * If not resolve all fonts, otherwise directly set the class to html
 */
/*
const fontA = new FontFaceObserver('fontA');
const fontB = new FontFaceObserver('fontB');

if (sessionStorage.fontsLoaded === true) {
    console.log('Fonts loaded via cache');
    alert('Fonts loaded via cache');
    document.documentElement.classList.add('wf-loaded');
} else {
    console.log('FontLoaded not in session storage');
    // Add all Variables defined above in the array of Promise.all
    Promise.all([fontA.load(), fontB.load()])
        .then(function() {
            console.log('Fonts loaded');
            document.documentElement.classList.add('wf-loaded');
            sessionStorage.fontsLoaded = true;
        })
        .catch((e) => {
            console.error(e);
            document.documentElement.classList.add('wf-failed');
            sessionStorage.fontsLoaded = false;
        });
}
*/

/**
 * Single Font Example
 fontA.load().then(function () {
    console.log('Fonts loaded');
    document.documentElement.classList.add('wf-loaded');
    sessionStorage.fontsLoaded = true;
}).catch(function () {
    console.error(e);
    document.documentElement.classList.add('wf-failed');
    sessionStorage.fontsLoaded = false;
});
 */

/***/ })

},[109]);


// WEBPACK FOOTER //
// js/app.9aacce5eec885143e6f2.min.js